import React from 'react';
import { useTranslation } from 'next-i18next';
import styles from './account-details-display.module.scss';

type AccountDetailsDisplayProps = {
  email: string;
};

const PASSWORD_PLACEHOLDER = '••••••••';

const AccountDetailsDisplay: React.FC<AccountDetailsDisplayProps> = ({ email }) => {
  const { t } = useTranslation('account-settings');

  return (
    <dl className={styles.accountDetailsDisplay}>
      <div className={styles.accountDetailsDisplay__row}>
        <dt className={styles.accountDetailsDisplay__label}>{t('ACCOUNT_SETTINGS.ACCOUNT_INFORMATION.EMAIL')}</dt>
        <dd
          className={styles.accountDetailsDisplay__value}
          data-cy="account-details-email"
        >
          {email}
        </dd>
      </div>
      <div className={styles.accountDetailsDisplay__row}>
        <dt className={styles.accountDetailsDisplay__label}>{t('ACCOUNT_SETTINGS.ACCOUNT_INFORMATION.PASSWORD')}</dt>
        <dd
          className={styles.accountDetailsDisplay__value}
          data-cy="account-details-password"
        >
          {PASSWORD_PLACEHOLDER}
        </dd>
      </div>
    </dl>
  );
};

export default AccountDetailsDisplay;
